import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      metrics: [],
      reference: null,
      initial: {
        key: null,
        0: {},
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        year: null,
        schools: {},
        groups: {},
        author: null,
        revision: 0,
        createdAt: null,
        updatedAt: null
      },
      headers_0_0: [
        { key: 117, name: '単価平均', group: 'X', type: 'header', id: 'TTL_SV', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_0_1: [
        { key: 114, name: '小学部単価', group: 'X', type: 'header', id: 'SV', calc: 'ave', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 101, name: '小1', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 102, name: '小2', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 103, name: '小3', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 104, name: '小4', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 105, name: '小5', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 106, name: '小6', group: 'B', type: 'SV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 115, name: '中学部単価', group: 'X', type: 'header', id: 'JV', calc: 'ave', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 107, name: '中1', group: 'B', type: 'JV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 108, name: '中2', group: 'B', type: 'JV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 109, name: '中3', group: 'B', type: 'JV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 116, name: '高校部単価', group: 'X', type: 'header', id: 'HV', calc: 'ave', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 110, name: '高1', group: 'B', type: 'HV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 111, name: '高2', group: 'B', type: 'HV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 112, name: '高3', group: 'B', type: 'HV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_0_2: [
        { key: 113, name: '既卒', group: 'B', type: 'HV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_0_3: [
        { key: 217, name: '売上合計', group: 'X', type: 'header', id: 'TTL_SS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_0_4: [
        { key: 214, name: '小学部売上', group: 'X', type: 'header', id: 'SS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 201, name: '小1', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 202, name: '小2', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 203, name: '小3', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 204, name: '小4', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 205, name: '小5', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 206, name: '小6', group: 'C', type: 'SS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 215, name: '中学部売上', group: 'X', type: 'header', id: 'JS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 207, name: '中1', group: 'C', type: 'JS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 208, name: '中2', group: 'C', type: 'JS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 209, name: '中3', group: 'C', type: 'JS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 216, name: '高校部売上', group: 'X', type: 'header', id: 'HS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 210, name: '高1', group: 'C', type: 'HS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 211, name: '高2', group: 'C', type: 'HS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 212, name: '高3', group: 'C', type: 'HS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_0_5: [
        { key: 213, name: '既卒', group: 'C', type: 'HS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers2_0: [
        { key: 214, name: '小学部売上', group: 'C', type: 'header', id: 'SS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 215, name: '中学部売上', group: 'C', type: 'header', id: 'JS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 216, name: '高校部売上', group: 'C', type: 'header', id: 'HS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers2_extension_1: [
        { key: 230, name: '幼児売上', group: 'C', type: 'header', id: 'YS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 214, name: '小学部売上', group: 'C', type: 'header', id: 'SS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 215, name: '中学部売上', group: 'C', type: 'header', id: 'JS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 216, name: '高校部売上', group: 'C', type: 'header', id: 'HS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_0_0: [
        { key: 100, name: '幼児単価', group: 'X', type: 'header', id: 'SV', calc: 'ave', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_0_1: [
        { key: 200, name: '幼児売上', group: 'X', type: 'header', id: 'SS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_1_0: [
        { key: 130, name: '幼児部単価', group: 'X', type: 'header', id: 'YV', calc: 'ave', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 126, name: '3歳', group: 'B', type: 'YV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 127, name: '4歳', group: 'B', type: 'YV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 128, name: '5歳', group: 'B', type: 'YV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 129, name: '6歳', group: 'B', type: 'YV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_1_1: [
        { key: 113, name: '社会人', group: 'B', type: 'HV', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_1_2: [
        { key: 230, name: '幼児部売上', group: 'X', type: 'header', id: 'YS', calc: 'add', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 226, name: '3歳', group: 'C', type: 'YS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 227, name: '4歳', group: 'C', type: 'YS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 228, name: '5歳', group: 'C', type: 'YS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } },
        { key: 229, name: '6歳', group: 'C', type: 'YS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ],
      headers_extension_1_3: [
        { key: 213, name: '社会人', group: 'C', type: 'HS', sufix: '円', roles: { admin: true, owner: true, chief: true, teacher: false, user: false } }
      ]
    }
  },
  getters: {
    metrics (state) {
      return state.metrics
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    },
    headers (state) {
      var headers = []
      var preschool = store.getters['shared/preschool']
      var extension = store.getters['shared/extension']
      if (preschool) {
        if (extension === 1) {
          headers = headers.concat(state.headers_0_0)
          headers = headers.concat(state.headers_extension_1_0)
          headers = headers.concat(state.headers_0_1)
          headers = headers.concat(state.headers_extension_1_1)
          headers = headers.concat(state.headers_0_3)
          headers = headers.concat(state.headers_extension_1_2)
          headers = headers.concat(state.headers_0_4)
          headers = headers.concat(state.headers_extension_1_3)
        } else {
          headers = headers.concat(state.headers_0_0)
          headers = headers.concat(state.headers_extension_0_0)
          headers = headers.concat(state.headers_0_1)
          headers = headers.concat(state.headers_0_2)
          headers = headers.concat(state.headers_0_3)
          headers = headers.concat(state.headers_extension_0_1)
          headers = headers.concat(state.headers_0_4)
          headers = headers.concat(state.headers_0_5)
        }
      } else {
        headers = headers.concat(state.headers_0_0)
        headers = headers.concat(state.headers_0_1)
        headers = headers.concat(state.headers_0_2)
        headers = headers.concat(state.headers_0_3)
        headers = headers.concat(state.headers_0_4)
        headers = headers.concat(state.headers_0_5)
      }
      return headers
    },
    headers2 (state) {
      var headers = state.headers2_0
      var preschool = store.getters['shared/preschool']
      var extension = store.getters['shared/extension']
      if (preschool) {
        if (extension === 1) {
          headers = state.headers2_extension_1
        }
      }
      return headers
    }
  },
  mutations: {
    init (state, payload) {
      state.metrics = payload
    },
    add (state, payload) {
      state.metrics.push(payload)
    },
    update (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        Vue.set(state.metrics, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.metrics.findIndex(metric => metric.key === payload.key)
      if (index !== -1) {
        state.metrics.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('metrics_fees')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['metricsFees/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('metrics_fees').doc(payload.key)
        } else {
          ref = db.collection('metrics_fees').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
            pause(0).then(() => {
              console.log('Document successfully written!')
              resolve()
            })
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('metrics_fees').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
